/**
 * Must match Clerk Dashboard → Billing → Organization Plans → Features.
 * Same slug as `WORKING_COPY_FEATURE` in backend billing/entitlement.ts.
 */
export const WORKING_COPY_FEATURE = "working_copy";
